import { GasPurePayload, GasPureScreenEventPayload } from '@atlaskit/analytics-gas-types';
import { AnalyticsWebClient as AnalyticsWebClientListener } from '@atlaskit/analytics-listeners';
import { useMemo } from 'react';

import AnalyticsClient from '../clients/AnalyticsClient';

import { useAnalytics } from './analytics';

/**
 * There is discrepancy between types in "@atlaskit/analytics-listeners"
 * and "@atlassiansox/analytics-web-client"
 */
export const getFabricAnalyticsListenerAdapter = (analyticsClient: AnalyticsClient) => {
  return {
    sendUIEvent: (event: GasPurePayload) => {
      analyticsClient.getAnalyticsWebClient().sendUIEvent({
        ...event,
        action: event.action || 'unknown',
        source: event.source || analyticsClient.getDefaultSource(),
      });
    },
    sendOperationalEvent: (event: GasPurePayload) => {
      analyticsClient.getAnalyticsWebClient().sendOperationalEvent({
        ...event,
        action: event.action || 'unknown',
        source: event.source || analyticsClient.getDefaultSource(),
      });
    },
    sendTrackEvent: (event: GasPurePayload) => {
      analyticsClient.getAnalyticsWebClient().sendTrackEvent({
        ...event,
        action: event.action || 'unknown',
        source: event.source || analyticsClient.getDefaultSource(),
      });
    },
    sendScreenEvent: (event: GasPureScreenEventPayload) => {
      analyticsClient.getAnalyticsWebClient().sendScreenEvent(event);
    },
  };
};

export const useFabricAnalyticsListenerAdapter = (): AnalyticsWebClientListener => {
  const analyticsClient = useAnalytics();
  return useMemo(() => getFabricAnalyticsListenerAdapter(analyticsClient), [analyticsClient]);
};
